"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columnsConfiguration = void 0;
var columnsConfiguration = [{
  // ID
  width: 125,
  label: "ID",
  dataKey: "partTerminologyID",
  researchDispatchKey: "SET_PART_TERMINOLOGY_ID_RESEARCH",
  headerProps: {
    withCheckbox: false
  }
}, {
  // Product
  width: 200,
  flexGrow: 2,
  label: "Product",
  dataKey: "partTerminologyName",
  researchDispatchKey: "SET_PART_TERMINOLOGY_NAME_RESEARCH",
  headerProps: {
    withCheckbox: false
  }
}, {
  // Categories
  width: 200,
  flexGrow: 1,
  label: "Categories",
  dataKey: "categoryName",
  researchDispatchKey: "SET_CATEGORY_NAME_RESEARCH",
  headerProps: {
    withCheckbox: false
  }
}, {
  // SubCategories
  width: 200,
  flexGrow: 1,
  label: "SubCategories",
  dataKey: "subCategoryName",
  researchDispatchKey: "SET_SUBCATEGORY_NAME_RESEARCH",
  headerProps: {
    withCheckbox: false
  }
}, {
  // Regions
  width: 130,
  label: "Regions",
  dataKey: "region",
  researchDispatchKey: "SET_REGION_RESEARCH",
  headerProps: {
    withCheckbox: false
  }
}, {
  // Availabilities
  width: 150,
  label: "Availabilities",
  dataKey: "availability",
  researchDispatchKey: "SET_AVAILABILITY_RESEARCH",
  headerProps: {
    withCheckbox: false
  }
}, {
  // OE Categories
  width: 130,
  label: "OE Cat.",
  dataKey: "oeCategory",
  researchDispatchKey: "SET_OE_CATEGORY_RESEARCH",
  headerProps: {
    withCheckbox: false
  }
}];
exports.columnsConfiguration = columnsConfiguration;